import React, {
  useEffect,
  useMemo,
} from "react";

import styled from "styled-components";
import { Icon } from "semantic-ui-react";


const Alertas = ({
  tipo = "info",
  mensaje = "",
  estadoAlerta,
  cambiarEstadoAlerta,
}) => {

  // =====================================================
  // CONFIGURACIÓN DEL TIPO DE ALERTA
  // =====================================================

  const config = useMemo(() => {

    const tipos = {
      exito: {
        icon: "check circle",
        background: "#21ba45",
      },

      error: {
        icon: "times circle",
        background: "#db2828",
      },

      warning: {
        icon: "warning circle",
        background: "#f2711c",
      },

      info: {
        icon: "info circle",
        background: "#2185d0",
      },
    };


    return (
      tipos[tipo] ||
      tipos.info
    );

  }, [tipo]);


  // =====================================================
  // AUTO CIERRE
  // =====================================================

  useEffect(() => {

    if (!estadoAlerta) {
      return;
    }


    const timer =
      setTimeout(() => {

        cambiarEstadoAlerta(false);

      }, 3500);


    return () => {
      clearTimeout(timer);
    };

  }, [
    estadoAlerta,
    cambiarEstadoAlerta,
  ]);


  // =====================================================
  // NO RENDERIZAR SI ESTÁ CERRADA
  // =====================================================

  if (!estadoAlerta) {
    return null;
  }


  // =====================================================
  // RETURN
  // =====================================================

  return (

    <Toast
      role="alert"
      $background={config.background}
    >

      <Icon
        name={config.icon}
        size="large"
        style={{
          margin: 0,
          flexShrink: 0,
        }}
      />


      <MessageText>
        {mensaje}
      </MessageText>


      <CloseButton
        type="button"
        aria-label="Cerrar alerta"
        title="Cerrar"
        onClick={() =>
          cambiarEstadoAlerta(false)
        }
      >

        <Icon
          name="close"
          fitted
        />

      </CloseButton>

    </Toast>

  );
};


export default Alertas;


// =======================================================
// STYLES
// =======================================================

const Toast = styled.div`

  position: fixed;

  top: 20px;
  left: 50%;

  transform: translateX(-50%);

  z-index: 99999;


  width: auto;

  min-width: 320px;
  max-width: min(520px, calc(100vw - 32px));


  padding: 13px 14px 13px 16px;

  border-radius: 8px;


  display: flex;

  align-items: center;

  gap: 12px;


  color: #ffffff;

  background: ${({ $background }) =>
    $background};


  border: 1px solid
    rgba(255, 255, 255, 0.18);


  box-shadow:
    0 8px 24px
    rgba(9, 30, 66, 0.22);


  animation:
    toastEntrada
    0.25s
    ease-out;


  @keyframes toastEntrada {

    from {

      opacity: 0;

      transform:
        translate(
          -50%,
          -12px
        );

    }

    to {

      opacity: 1;

      transform:
        translate(
          -50%,
          0
        );

    }

  }


  @media (max-width: 480px) {

    top: 12px;

    min-width: 0;

    width:
      calc(
        100vw - 24px
      );

  }

`;


const MessageText = styled.div`

  flex: 1;

  min-width: 0;


  font-size: 14px;

  font-weight: 500;

  line-height: 1.4;


  word-break: break-word;

`;


const CloseButton = styled.button`

  width: 30px;

  height: 30px;


  flex-shrink: 0;


  display: flex;

  align-items: center;

  justify-content: center;


  margin: 0;

  padding: 0;


  border: none;

  border-radius: 6px;


  color: #ffffff;

  background:
    rgba(
      255,
      255,
      255,
      0.10
    );


  cursor: pointer;


  transition:
    background 0.15s ease,
    opacity 0.15s ease;


  opacity: 0.85;


  &:hover {

    opacity: 1;

    background:
      rgba(
        255,
        255,
        255,
        0.18
      );

  }


  &:focus-visible {

    outline:
      2px solid
      rgba(
        255,
        255,
        255,
        0.9
      );

    outline-offset: 2px;

  }

`;